import { ConfigService } from '../../';

export class MapLegend {
	 public color	= ''
	 public image	= ''
	 public text	= ''

	 constructor(configService: ConfigService, text: string, color?: string, image?: string) {
		 this.color	= configService.getColor(color, this.color);
		 this.image	= typeof image === 'string' ? configService.getImage(image) : this.image;
		 this.text	= text;
	 }
}


// WEBPACK FOOTER //
// ./src/app/electraLib/model/map/mapLegend.ts